import React from 'react';
import Popup from './popup_base.jsx';
import { NotificationButtons } from './popup_constants.js';
import { withTranslation, Trans } from 'react-i18next';

class NotificationPopup extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    submit() {
        this.props.closeAction();
        this.props.submitAction();
    }

    cancel() {
        if (typeof(this.props.closePopupAction) === 'function') {
            this.props.closePopupAction();
        }
        this.props.closeAction();
    }

    render() {
        const props = { ...this.props };
        props.width = props.width ? props.width : "400px";
        props.height = props.height ? props.height : "180px";
        let buttons = props.buttons;
        if (!Array.isArray(buttons) || buttons.length === 0) {
            buttons = [NotificationButtons.OK, NotificationButtons.CANCEL];
        }
        const isOkButtonDisplayed = buttons.indexOf(NotificationButtons.OK) >= 0;
        const isYesButtonDisplayed = buttons.indexOf(NotificationButtons.YES) >= 0;
        const isNoButtonDisplayed = buttons.indexOf(NotificationButtons.NO) >= 0;
        const isCancelButtonDisplayed = buttons.indexOf(NotificationButtons.CANCEL) >= 0;

        return (
            <Popup {...props}>
                <div>
                    <div>
                        <div style={{margin: '10px', height: '100%', width: '100%'}}>{this.props.message}</div>
                    </div>
                    <div className="popup-buttons-container" style={{ position: 'absolute', bottom: '5px', right: '5px' }}>
                        {isOkButtonDisplayed && <button onClick={this.submit}><Trans>Popups.OkButtonText</Trans></button>}
                        {isYesButtonDisplayed && <button onClick={this.submit}><Trans>Popups.YesButtonText</Trans></button>}
                        {isNoButtonDisplayed && <button onClick={this.cancel}><Trans>Popups.NoButtonText</Trans></button>}
                        {isCancelButtonDisplayed && <button onClick={this.cancel}><Trans>Popups.CancelButtonText</Trans></button>}
                    </div>
                </div>
            </Popup>
        );
    }
}

export default withTranslation("translations")(NotificationPopup);